import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
dayjs.extend(isoWeek);

export function formatIsoDate(timestamp) {
  return dayjs(timestamp || Date.now()).format("YYYY-MM-DD");
}

export function formatEDSDate(timestamp, countryId) {
  const dateObject = new Date(timestamp);

  const fullYear = dateObject.getUTCFullYear();
  const shortYear = String(fullYear).slice(2);
  const month = String(dateObject.getUTCMonth() + 1).padStart(2, "0"); // getUTCMonth() returns 0-based month
  const day = String(dateObject.getUTCDate()).padStart(2, "0");

  const currentYear = dayjs().year();
  if (fullYear === currentYear) {
    return countryId === "US" ? `${day}/${month}` : `${month}/${day}`;
  } else {
    return countryId === "US"
      ? `${shortYear}/${day}/${month}`
      : `${shortYear}/${month}/${day}`;
  }
}

export function getSalesWeekFromDate(currentDate) {
  // isoWeek returns the week number from Monday to Sunday. Sales week is shifted
  // and is from Sunday to Saturday. We add one day so that we get the correct week
  // number for Sunday.
  return dayjs(currentDate || Date.now())
    .add(1, "day")
    .isoWeek();
}
